// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3n4id","content":"styles_content__2urC_","checkbox":"styles_checkbox__2VBJt","checkboxLabel":"styles_checkboxLabel__BbKcQ"};